import { Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection } from 'typeorm';
import {Roles} from './role-entity';
import {RoleDTO} from './dto/role-dto';
import { InjectRepository } from '@nestjs/typeorm';
import {RolesAdapter} from './dto/role-adapter';
import {RolesResponse,AllRolesResponse} from '@gtpl/shared-models/masters';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { RolesRequest } from './dto/role-request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';


@Injectable()
export class RoleMasterService {

    constructor(
      private logService:LogsService,

        @InjectRepository(Roles)
        private rolesRepository: Repository<Roles>,
        private rolesAdapter: RolesAdapter ,
    ){}

    async getRoleDetailsWithoutRelations(roleName: string): Promise<Roles> {
        // tslint:disable-next-line: typedef
        const roleResponse = await this.rolesRepository.findOne({
          where: {roleName:roleName},
        });
        if (roleResponse) {
          return roleResponse;
        } else {
          return null;
        }
      }

      async createRole(roleDto: RoleDTO, isUpdate: boolean): Promise<RolesResponse> {
        
        try {
             if (!isUpdate) {
            const rolesEntity = await this.getRoleDetailsWithoutRelations(roleDto.roleName);
            if (rolesEntity) {
              //return new InformationMessageError(11104, "State already exists");
              throw new ErrorResponse(11104, 'Role already exists');
            }
          }
          else{
            const rolesEntity = await this.getRoleDetailsWithoutRelations(roleDto.roleName);
            if(rolesEntity){
                if(rolesEntity.roleId!=roleDto.roleId) {
                    throw new ErrorResponse(11104, 'Role already exists');      
                }
            }
          }
          const convertedRoleEntity: Roles = this.rolesAdapter.convertDtoToEntity(roleDto,isUpdate);
          const savedRoleEntity: Roles = await this.rolesRepository.save(
            convertedRoleEntity
          );
          const savedRoleDto: RoleDTO = this.rolesAdapter.convertEntityToDto(convertedRoleEntity);
                     if (savedRoleDto) {
            // generating resposnse
        const response = new RolesResponse(true,1,isUpdate? 'Role Updated Successfully': 'Role Created Successfully');
        const name=isUpdate?'updated':'created'
            
            const newLogDto = new LogsDto(1,name, 'Roles', savedRoleDto.roleId, true, '',savedRoleDto.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
        return response;

          } else {
            //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new ErrorResponse(11106,'Role saved but issue while transforming into DTO');
          }
        } catch (error) {
          // when error occures while saving the data , the execution will come to catch block.
          // tslint:disable-next-line: typedef
          throw error;
        }
      }  
      async getAllRoles(): Promise<AllRolesResponse> {
        // const page: number = 1;
        try {
          const roleDtos: RoleDTO[] = [];
          //retrieves all companies
          const rolesEntities: Roles[] = await this.rolesRepository.find({order :{roleName:'ASC'}});
          //console.log(statesEntities);
          if (rolesEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            rolesEntities.forEach(RoleEntity => {
              const convertedrolesDto: RoleDTO = this.rolesAdapter.convertEntityToDto(
                RoleEntity
              );
              roleDtos.push(convertedrolesDto);
            });
    
            //generated response
        const response = new AllRolesResponse(true,1,'Roles retrieved successfully',roleDtos);
        const newLogDto = new LogsDto(1,'view', 'Roles', 0, true, '','')
        let res = await this.logService.createLog(newLogDto);
        console.log(res);
        return response;
        
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        } catch (err) {
          throw err;
        }
      }
      async getAllActiveRoles(): Promise<AllRolesResponse> {
        // const page: number = 1;
        try {
            const rolesDtos: RoleDTO[] = [];
            //retrieves all companies
            const rolesEntities: Roles[] = await this.rolesRepository.find({ order: { roleName: 'ASC' },
           });
         console.log(rolesEntities)
            if (rolesEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                rolesEntities.forEach(RoleEntity => {
                    const convertedrolesDto: RoleDTO = this.rolesAdapter.convertEntityToDto(
                      RoleEntity
                    );
                    rolesDtos.push(convertedrolesDto);
                });
                const response = new AllRolesResponse(true, 11108, "Roles retrieved successfully", rolesDtos);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found'); rolesDtos;
            }
        } catch (err) {
            throw err;
        }
    }
      async activateOrDeactivateRole(rolesReq: RolesRequest): Promise<RolesResponse> {
        try {            const roleExists = await this.getRoleById(rolesReq.roleId);
            if (roleExists) {
                if (rolesReq.versionFlag !== roleExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current role information.Refresh and try again');
                } else {
                    
                        const roleStatus =  await this.rolesRepository.update(
                            { roleId: rolesReq.roleId },
                            { isActive: rolesReq.isActive,updatedUser: rolesReq.updatedUser });
                       
                        if (roleExists.isActive) {
                            if (roleStatus.affected) {
                                const roleResponse: RolesResponse = new RolesResponse(true, 10115, 'Role is de-activated successfully');
                                return roleResponse;
                            } else {
                                throw new ErrorResponse(10111, 'Role is already deactivated');
                            }
                        } else {
                            if (roleStatus.affected) {
                                const roleResponse: RolesResponse = new RolesResponse(true, 10114, 'Role is activated successfully');
                                return roleResponse;
                            } else {
                                throw new ErrorResponse(10112, 'Role is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getRoleById(roleId: number): Promise<Roles> {
        //  console.log(employeeId);
            const Response = await this.rolesRepository.findOne({
            where: {roleId: roleId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }
}
